module.exports = __webpack_public_path__ + "static/media/iconeechographiemarternelle.0d5dfe73.png";